import { useCallback, useState } from "react";

// State of a reCAPTCHA widget. A token works once, so after every use the widget is
// remounted (new resetKey) and the learner must solve a fresh one.
export const useCaptcha = () => {
    const [token, setToken] = useState("");
    const [resetKey, setResetKey] = useState(0);

    const reset = useCallback(() => {
        setToken("");
        setResetKey((key) => key + 1);
    }, []);

    return { token, setToken, resetKey, reset };
};